let paymentStatusSorts = []
let dishTypeList = []
let mealPackageTypeSorts = []
let mealPackageDropDownList = []
let dishesList = []
let validPackageList = []
let takeMealStatusSorts = []

export default {
  paymentStatusSorts,
  mealPackageTypeSorts,
  mealPackageDropDownList,
  dishesList,
  dishTypeList,
  validPackageList,
  takeMealStatusSorts
}



// WEBPACK FOOTER //
// ./src/store/order/state.js